import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { DropIndicator } from "app/components/DropIndicator";
import { selectSelectedTickets } from "../../../../redux/selector";
import { actions } from "../../../../redux/slice";
import { ITickets, TicketGroup } from "../../../Tickets/types";
import TicketCard from "./Ticket";
import { useCardDragDrop } from "../../../../components/ticketDragHook";

interface DraggableColumnProps {
  ticket: ITickets;
  group: TicketGroup;
  subGroupId?: string;
  parentGroupId?: string;
}

const DraggableColumn: React.FC<DraggableColumnProps> = ({
  ticket,
  group,
  subGroupId,
  parentGroupId,
}) => {
  const dispatch = useDispatch();
  const selectedTickets = useSelector(selectSelectedTickets);

  const { ticketRef, closestEdge } = useCardDragDrop({
    ticket,
    group,
    subGroupId,
    parentGroupId,
  });

  const handleToggleSelection = (t: ITickets) => {
    dispatch(actions.toggleSelectTicket({ group, ticket: t }));
  };

  return (
    <div
      ref={ticketRef}
      data-ticket-card
      data-ticket-id={ticket._id}
      style={{ position: "relative" }}
    >
      {closestEdge === "top" && <DropIndicator edge="top" gap="12px" />}

      <TicketCard
        ticket={ticket}
        isSelected={selectedTickets?.id?.includes(ticket._id)}
        onCheckboxClick={handleToggleSelection}
        group={group}
      />

      {closestEdge === "bottom" && <DropIndicator edge="bottom" gap="12px" />}
    </div>
  );
};

export default DraggableColumn;
